import login from './login'
import user from './user'

export default {
  login,
  user
}
